module.exports = __webpack_public_path__ + "static/media/nimes_verteiler_tn.6c39bdd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/nimes_verteiler_tn.jpg
// module id = 742
// module chunks = 0